import type {ReactAction} from '@netx/core/bootstrap';
import {dispatcher} from '@netx/core-next/instance/dispatcher';
import {faArchive} from '@netx/core-icons';
import {canManageCurrentCartArchive} from '../enablers';
import {CART_CURRENT_ACTION_LABELS} from '../locales';
import {CART_CURRENT_EVENT} from './constants';

/**
 * Archive cart assets
 * @param params
 * @returns Action
 */
export const cartActionManageArchiveArchive = (
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'current-cart-manage-archive-archive',
	get label() {
		return CART_CURRENT_ACTION_LABELS.MANAGE_ARCHIVE_ARCHIVE;
	},
	icon: faArchive,
	enableTest: canManageCurrentCartArchive,
	cb: () => dispatcher.trigger(CART_CURRENT_EVENT.MANAGE_ARCHIVE_ARCHIVE),
	...params,
});

export default cartActionManageArchiveArchive;
